import { render } from "./affiliate-review-page.vue?vue&type=template&id=695c73fa&scoped=true&ts=true"
import script from "./affiliate-review-page.vue?vue&type=script&lang=ts"
export * from "./affiliate-review-page.vue?vue&type=script&lang=ts"

import "./affiliate-review-page.vue?vue&type=style&index=0&id=695c73fa&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-695c73fa"]])

export default __exports__